import React from 'react';
import Plot from 'react-plotly.js';
import { Card, Typography, Descriptions, Row, Col, Space } from 'antd';

const { Title, Text } = Typography;

const PlotlyJsonChart = ({ data }) => {
  if (!data?.plot_data) {
    return null;
  }

  const renderSingleChart = (plotConfig, index = 0) => {
    const config = typeof plotConfig === 'string'
      ? JSON.parse(plotConfig)
      : plotConfig;

    return (
      <div key={index} style={{ width: '100%', height: 'calc(50vh - 32px)', minHeight: '400px' }}>
        <Plot
          data={config.data}
          layout={{
            ...config.layout,
            autosize: true,
            margin: { t: 20, r: 20, l: 50, b: 50 },
            paper_bgcolor: 'transparent',
            plot_bgcolor: 'transparent',
            font: {
              family: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial'
            }
          }}
          config={{
            responsive: true,
            displayModeBar: false,
            ...config.config
          }}
          style={{ width: '100%', height: '100%' }}
          useResizeHandler={true}
        />
      </div>
    );
  };

  const renderDashboard = (plotConfigs) => {
    return (
      <Space direction={'vertical'} gutter={[16, 16]} style={{ width: '100%', minHeight: 'calc(100vh - 200px)' }}>
        {plotConfigs.map((config, index) => (
            <Card className={'gapless'} bordered={false}>
              {renderSingleChart(config, index)}
            </Card>
        ))}
      </Space>
    );
  };

  return (
      <Card className={'gapless'}
            style={{width: '100%'}}
            bordered={false}
      >
          {data.metadata && Object.keys(data.metadata).length > 0 && (
              <div className={'my-6 px-6'}>
                  <Descriptions column={{xs: 1, sm: 2}} size="small" bordered className={'bordered round-2 p-3'}>
                      <Descriptions.Item label={'Created On'}>
                          {new Date(data.created_at).toLocaleString()}
                      </Descriptions.Item>
                      <Descriptions.Item label={'Last Updated'}>
                          {new Date(data.updated_at).toLocaleString()}
                      </Descriptions.Item>
                      {Object.entries(data.metadata).map(([key, value]) => (
                          <Descriptions.Item key={key} label={key}>
                              {value}
                          </Descriptions.Item>
                      ))}
                  </Descriptions>
              </div>
          )}
          {data.description && (
              <Text type="secondary" style={{display: 'block', marginBottom: 24}}>
                  {data.description}
              </Text>
          )}

          {data.plot_type === 'dashboard'
              ? renderDashboard(data.plot_data)
              : renderSingleChart(data.plot_data)
          }

      </Card>
  );
};

export default PlotlyJsonChart;